// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import styled from 'styled-components';
import ReactPlayer from 'react-player';
import PlayerControl from './PlayerControl';

const otherS = {
  PlayerControl: styled(PlayerControl)<{ hide: boolean }>`
    ${({ hide }) => hide ? { display: 'none' }: null }
  `,
}

export const S = {
  ...otherS,
  Wrapper: styled.div`
    width: 100%;
    height: 100%;
    position: relative;
    background-color: black;
    display: flex;
    align-items: center;

    &:hover ${otherS.PlayerControl}{
      visibility: visible;
    }
  `,
  Player: styled(ReactPlayer) <{ hide: boolean }>`
    width: 100%;
    height: 100%;
    max-width: 100%;
    max-height: 100%;
    ${({ hide }) => hide ? { display: 'none !important' } : null }
  `,
  PIPLayout: styled.div`
    position: absolute;
    top: 0px;
    left: 0px;
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    /* background-color: #313131; */
  `,
  Information: styled.div`
    font-size: 24px;
    line-height: 35px;
    color: #FFFFFF;
  `,
  PipToggle: styled.div`
    font-size: 20px;
    line-height: 29px;
    text-decoration-line: underline;
    color: #FCA032;
    cursor: pointer;
  `,
};
